import { Injectable, inject } from '@angular/core';

import { IconsModel } from './icons-model';
import { IconsetConfig } from './icons.client-config';

@Injectable({ providedIn: 'root' })
export class IconFastService {
    readonly config = inject(IconsetConfig);

    getIconParameter(name: string, parameter: string): string {
        const icon = this.config.iconItems?.find((data: IconsModel) => data.name === name || data.iconName === name);

        if (!icon) {
            return '';
        }

        switch (parameter) {
            case 'urlId':
                return icon.parameters?.urlId ?? icon.image?.src ?? icon.imageUrl ?? '';
            case 'size':
                return icon.parameters?.size ?? icon.size ?? '';
            case 'extraClass':
                return icon.parameters?.extraClass ?? icon.extraClass ?? '';
            case 'fillColor':
                return icon.parameters?.fillColor ?? icon.fillColor ?? '';
            case 'title':
                return icon.parameters?.title ?? icon.title ?? '';
            default:
                return '';
        }
    }
}
